import type { Modifier } from '@dnd-kit/core';

export const shiftOverlayBy =
  (px: number, py: number): Modifier =>
  ({ transform }) => ({
    ...transform,
    x: transform.x - px,
    y: transform.y - py,
  });
